const listAttributes = [
  'student',
  'classId',
  'lesson',
  'course',
  'present',
  'homework',
  'enrolmentMethod',
  'attendanceType',
  'startDatetime',
  'attendanceNotified',
  'billingType',
  'rollMarked',
  'separatelyBilled',
  'stream',
] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = [
  'present',
  'homework',
  'enrolmentMethod',
  'attendanceType',
  'attendanceNotified',
] as const;

export const LessonEnrolmentAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
